import { getPlugin as getBugsnagPlugin, startBugsnag } from '@app/bugsnag'
import router from '@app/router'
import { trickleInjectionKey, useTrickle } from '@dailycare-au/ui'
import { setupUI } from '@dailycare-au/ui'
import { createHead } from '@unhead/vue/client'
import { createPinia } from 'pinia'
import { DataLoaderPlugin } from 'vue-router/experimental'
import { createApp } from 'vue'
import App from './app.vue'
import './tailwind.css'
import { client } from '@common/api/client.gen'

client.setConfig({ baseUrl: new URL('/consumer/v2', import.meta.env.VITE_API_URL).href })

startBugsnag()

const app = createApp(App)

app.use(getBugsnagPlugin('vue')!)
app.use(createHead())
app.use(createPinia())
app.provide(trickleInjectionKey, useTrickle())

app.use(DataLoaderPlugin, { router })
app.use(router)

setupUI(app)

app.mount('#app')
